/* eslint-disable camelcase */
import styled from 'styled-components'

import { SlideMedia } from '../../../../../routes/Home/Old/types'
import { media } from '../../../../../utils/style-utils'

interface Props {
  shouldLoadBackground: boolean
  media: SlideMedia
}

export default styled.div<Props>`
  position: absolute;
  width: 100%;
  height: 100%;
  display: ${({ shouldLoadBackground }) => (shouldLoadBackground ? 'inherit' : 'none')};

  left: 50%;
  transform: translateX(-50%);

  background-image: url(${({ media: { bgLandscape } }) => bgLandscape.lg.jpg});
  background-size: cover;
  background-position: left center;
  background-repeat: no-repeat;

  ${media.md`
    background-position: center;
  `}
`
